module.exports = __webpack_public_path__ + "static/media/heart-red.a9ba4023.svg";